import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import k1 from "../assets/k1.png";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Rating,
  Tab,
  Tabs,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { motion } from "framer-motion";
import Header from "./Header";
import Footer from "./Footer";

const faqData = [
  {
    question: "What is the IGNOU Online Astrology course?",
    answer:
      "The IGNOU Online & Distance Astrology course is designed for beginners and enthusiasts to learn astrology from scratch.",
  },
  {
    question: "How can I enroll in the course?",
    answer:
      "Submit your contact details and our team will guide you through the enrollment process.",
  },
  {
    question: "What is the course duration?",
    answer:
      "The course typically lasts for 6 months, with flexible online learning options.",
  },
  {
    question: "Are there any prerequisites?",
    answer:
      "No prior knowledge is required; the course is suitable for beginners.",
  },
  {
    question: "Will I receive a certificate?",
    answer:
      "Yes, upon completion, you will receive an IGNOU accredited certificate.",
  },
];

const KarmKaandDetail = () => {
  const [tabValue, setTabValue] = useState("description");
  const [expanded, setExpanded] = useState(false);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);

    const section = document.getElementById(newValue);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleChanges = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };
  const itemVariantsLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };

  const itemVariantsRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };
  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <>
      <Header />
      <Grid
        component={motion.div}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
        container
        sx={{ p: { xs: 2, md: 6 } ,mt:10}}
        spacing={5}
        
      >
        <Grid size={{ xs: 12, md: 12 }}>
          <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
            <Typography sx={{ fontWeight: "bold" }}>Home</Typography>
            <ChevronRightIcon fontSize="small" />
            <Typography sx={{ fontWeight: "bold" }}>Services</Typography>
            <ChevronRightIcon fontSize="small" />
            <Typography sx={{ fontWeight: "bold" }}>Ceremonies</Typography>
            <ChevronRightIcon fontSize="small" />
            <Typography color="primary" sx={{ fontWeight: "bold" }}>
              Aksharabhyasam
            </Typography>
          </Box>
        </Grid>
        <Grid
          component={motion.div}
          variants={itemVariantsLeft}
          size={{ xs: 12, md: 5 }}
        >
          <img
            src={k1}
            alt="Aksharabhyasam"
            style={{
              width: "100%",
              height: "auto",
              border: "1px solid grey",
              borderRadius: "8px",
            }}
          />
        </Grid>
        <Grid
          component={motion.div}
          variants={itemVariantsRight}
          size={{ xs: 12, md: 7 }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 1,
            }}
          >
            {" "}
            <Typography sx={{ fontWeight: "bold", fontSize: 20 }}>
              Aksharabhyasam
            </Typography>
            <Rating
              name="half-rating-read"
              defaultValue={5}
              precision={0.5}
              readOnly
              sx={{ fontSize: 20 }}
            />
            <Typography sx={{ color: "green" }}>
              (20 customer reviews)
            </Typography>
          </Box>
          <Typography sx={{ color: "#4a4a4a", fontWeight: 700 }}>
            Price Range :{" "}
            <span
              style={{ color: "#787878", fontWeight: 400, fontStyle: "italic" }}
            >
              Rs 3,800.00 - Rs 7,800.00
            </span>
          </Typography>
          <Box
            sx={{
              //   width: { xs: "90%", md: "100%" },
              mt: 0,
              ml:{xs:0,md:2},
            //   border: "1px double #ccc",
              borderRadius: 2,
              p: 2,
              textAlign: "justify",
            }}
          >
            <Typography>
              <span style={{ fontWeight: 600 }}>Aksharabhyasam</span> is one of
              the 16 sanskaras to be performed, in which when the baby attains
              age two years and above will be initiated to write the first
              letter for the first time in order to get the blessings from Matha
              Saraswati and Lord Ganesh by performing the Aksharabhyasam pooja
              to start their schooling life successfully.
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Typography sx={{ fontWeight: "bold", mb: 0 }}>
                Key Insights :
              </Typography>
              <List>
                <ListItem sx={{ py: 0, alignItems: "flex-start" }}>
                  <ListItemIcon sx={{ minWidth: 20, color: "#333" }}>
                    <Typography variant="h6" sx={{ lineHeight: 1.5 }}>
                      •
                    </Typography>
                  </ListItemIcon>
                  <ListItemText primary="Baby writes for the first time with Lord's blessings." />
                </ListItem>

                <ListItem sx={{ py: 0, alignItems: "flex-start" }}>
                  <ListItemIcon sx={{ minWidth: 20, color: "#333" }}>
                    <Typography variant="h6" sx={{ lineHeight: 1.5 }}>
                      •
                    </Typography>
                  </ListItemIcon>
                  <ListItemText primary="It helps the baby to grow healthy and strong." />
                </ListItem>

                <ListItem sx={{ py: 0, alignItems: "flex-start" }}>
                  <ListItemIcon sx={{ minWidth: 20, color: "#333" }}>
                    <Typography variant="h6" sx={{ lineHeight: 1.5 }}>
                      •
                    </Typography>
                  </ListItemIcon>
                  <ListItemText primary="Performed on 2nd or 3rd year on any auspicious day." />
                </ListItem>

                <ListItem sx={{ py: 0, alignItems: "flex-start" }}>
                  <ListItemIcon sx={{ minWidth: 20, color: "#333" }}>
                    <Typography variant="h6" sx={{ lineHeight: 1.5 }}>
                      •
                    </Typography>
                  </ListItemIcon>
                  <ListItemText primary="Mantras are chanted for the baby’s well-being." />
                </ListItem>
              </List>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Typography sx={{ fontWeight: "bold", mb: 0 }}>
                Our Promise :
              </Typography>
              <List>
                <ListItem sx={{ py: 0, alignItems: "flex-start" }}>
                  <ListItemIcon sx={{ minWidth: 20, color: "#333" }}>
                    <Typography variant="h6" sx={{ lineHeight: 1.5 }}>
                      •
                    </Typography>
                  </ListItemIcon>
                  <ListItemText primary="Vedic Patashala certified and experienced priests." />
                </ListItem>

                <ListItem sx={{ py: 0, alignItems: "flex-start" }}>
                  <ListItemIcon sx={{ minWidth: 20, color: "#333" }}>
                    <Typography variant="h6" sx={{ lineHeight: 1.5 }}>
                      •
                    </Typography>
                  </ListItemIcon>
                  <ListItemText primary="All rituals follow Vedic Standards and Procedures" />
                </ListItem>

                <ListItem sx={{ py: 0, alignItems: "flex-start" }}>
                  <ListItemIcon sx={{ minWidth: 20, color: "#333" }}>
                    <Typography variant="h6" sx={{ lineHeight: 1.5 }}>
                      •
                    </Typography>
                  </ListItemIcon>
                  <ListItemText primary="High-quality Samagri(items) to ensure a pleasant Pooja experience." />
                </ListItem>

                <ListItem sx={{ py: 0, alignItems: "flex-start" }}>
                  <ListItemIcon sx={{ minWidth: 20, color: "#333" }}>
                    <Typography variant="h6" sx={{ lineHeight: 1.5 }}>
                      •
                    </Typography>
                  </ListItemIcon>
                  <ListItemText primary="Guaranteed Punctuality and Authenticity." />
                </ListItem>
                <ListItem sx={{ py: 0, alignItems: "flex-start" }}>
                  <ListItemIcon sx={{ minWidth: 20, color: "#333" }}>
                    <Typography variant="h6" sx={{ lineHeight: 1.5 }}>
                      •
                    </Typography>
                  </ListItemIcon>
                  <ListItemText primary="Professional Guidance & Support." />
                </ListItem>
              </List>
            </Box>
          </Box>
        </Grid>
        <Grid
          component={motion.div}
          variants={itemVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          container
          sx={{
            // border: "1px solid #ccc",
            borderRadius: 2,
            boxShadow: 5,
            bgcolor: "#fff",
            width: "100%" 
          }}
        >
          <Box
            sx={{
              width: "90%",
              bgcolor: "#6d1675",
              position: "sticky",
              top: 90,
              zIndex: 1000,
              display: "flex",
              justifyContent: "center",
              mx: "auto",
              px: 2,
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              TabIndicatorProps={{ style: { backgroundColor: "transparent" } }}
            >
              <Tab
                label="Description"
                value="description"
                sx={{
                  color: "white",
                  textTransform: "none",
                  "&.Mui-selected": { bgcolor: "#ffc20f" },
                  fontSize: 15,
                  fontWeight: "bold",
                  mx: 2,
                }}
              />
              <Tab
                label="Reviews (20)"
                value="reviews"
                sx={{
                  color: "white",
                  textTransform: "none",
                  "&.Mui-selected": { bgcolor: "#ffc20f" },
                  fontSize: 15,
                  fontWeight: "bold",
                  mx: 2,
                }}
              />
              <Tab
                label="FAQ"
                value="faq"
                sx={{
                  color: "white",
                  textTransform: "none",
                  "&.Mui-selected": { bgcolor: "#ffc20f" },
                  fontSize: 15,
                  fontWeight: "bold",
                  mx: 2,
                }}
              />
            </Tabs>
          </Box>
          <Box sx={{ width: "100%" }}>
            {tabValue === "description" && (
              <Box sx={{ p: 4, bgcolor: "#fff" }}>
                <Typography sx={{ mb: 2, mt: -1, textAlign: "justify" }}>
                  Aksharabhyasam is also known as Vidhyarambham is a religious
                  function in which the baby is given initiation for education.
                  By doing this ceremony as per shastras, the child is ready to
                  receive formal school education with the blessings of Lord
                  Ganesha and Matha Saraswati.
                </Typography>

                <Typography sx={{ mb: 2, mt: -1, textAlign: "justify" }}>
                  This ceremony is one of the Sodas Sankara ( 16 Sanskaras),
                  which every Hindu has to undergo. The meaning of Akshara is
                  alphabets in Sanskrit. Abhyasam means to practice.
                  Aksharabhyasam aims at giving the initial practice of writing
                  letters to the child. This ceremony is generally performed
                  when the baby turns two or two and a half years old.
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mb: 2, mt: 2 }}
                >
                  When to Perform Aksharabhyasam?
                </Typography>
                <Typography sx={{ mb: 2, mt: -1, textAlign: "justify" }}>
                  This ceremony is usually performed on auspicious days like
                  Vasant Panchami, Vijaya Dasami, Saraswati Pooja day, Guru
                  Poornima, Dussehra, Navaratri, Sravana Pournami, Poornima,
                  Ugadi, or Gudi Pudva day, or any other good muhurta dates.
                </Typography>
              </Box>
            )}

            {tabValue === "reviews" && (
              <Box sx={{ p: 4, bgcolor: "#fff" }}>
                {[1, 2, 3, 4].map((i) => (
                  <Box
                    key={i}
                    sx={{
                      mt: 2,
                      borderRadius: 2,
                      border: "1px solid #ccc",
                      p: 2,
                    }}
                  >
                    <Typography>
                      My entire family appreciates your dedication and the way
                      you perform the rituals
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        mt: 2,
                        gap: 1,
                      }}
                    >
                      <Typography>
                        <Box component="span" sx={{ fontWeight: 700 }}>
                          Kalyani Ramakrishnan
                        </Box>{" "}
                        Nov 08, 2024
                      </Typography>
                      <Typography>Pooja performance rating</Typography>
                      <Box
                        sx={{ display: "flex", gap: 1, alignItems: "center" }}
                      >
                        <Rating
                          name="half-rating-read"
                          defaultValue={5}
                          precision={0.5}
                          readOnly
                          sx={{ fontSize: 20 }}
                        />
                        <Typography>5/5</Typography>
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}

            {tabValue === "faq" && (
              <Box sx={{ px: 6, py: 4 }}>
                {faqData.map((faq, index) => (
                  <Box key={index} sx={{ width: "95%" }}>
                    <Accordion
                      expanded={expanded === `panel${index}`}
                      onChange={handleChanges(`panel${index}`)}
                      sx={{
                        bgcolor: "transparent",
                        boxShadow: "none",
                        "&:before": { display: "none" },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          expanded === `panel${index}` ? (
                            <RemoveIcon />
                          ) : (
                            <AddIcon />
                          )
                        }
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            mb: 1,
                            mt: 1,
                            fontSize: { xs: 14, md: 16 },
                          }}
                        >
                          {faq.question}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography sx={{ fontSize: { xs: 13, md: 15 } }}>
                          {faq.answer}
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                    {index < faqData.length - 1 && (
                      <Divider sx={{ bgcolor: "#ccc" }} />
                    )}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
      <Footer/>
    </>
  );
};

export default KarmKaandDetail;

